import { LanguageDto } from "./languagedto";
import { pageDto } from "./pagedto";

export class LanguageResponse {

    languageDto: LanguageDto [] = [];
    
    pageDto: pageDto = new pageDto({});

}